import type { Element } from '@xmpp/xml'
import { nanoid } from 'nanoid'
import { Marker } from '../../chat-data/types'
import {
  getMarkerStanza,
  getForwardedStanza,
  getMessageStanza,
  getMessageStanzaData,
  getArchiveStanza,
  getStanzaId,
  getDelayStanzaStamp,
  getDelayStanza,
  isGroupchatMarkerStanza,
} from '../helpers'
import { EventStatus } from '../XMPPClient'
import { getRoomAndUserId } from './getRoomAndUserId'

export const parseGroupchatMarkerStanza = (stanza: Element): Marker | undefined => {
  if (!isGroupchatMarkerStanza(stanza)) {
    return
  }
  const markerStanza = getMarkerStanza(stanza)
  const id = getStanzaId(stanza)
  const { from: messageFrom } = getMessageStanzaData(stanza)
  const { id: messageId } = getMessageStanzaData(markerStanza)
  const { userId, roomId } = getRoomAndUserId(messageFrom)
  const timestamp = getDelayStanzaStamp(getDelayStanza(stanza))

  if (!id || !roomId || !messageId || !userId) {
    return
  }

  return {
    id,
    roomId,
    type: 'Marker',
    timestamp: timestamp,
    eventId: messageId,
    author: userId,
    status: markerStanza?.getName() as EventStatus,
  }
}

export const parseArchivedGroupchatMarkerStanza = (stanza: Element): Marker | undefined => {
  const archiveStanza = getArchiveStanza(stanza)
  const archiveForwarded = getForwardedStanza(archiveStanza)
  const messageStanza = getMessageStanza(archiveForwarded)
  if (!isGroupchatMarkerStanza(messageStanza)) {
    return
  }
  const timestamp = getDelayStanzaStamp(getDelayStanza(archiveForwarded))
  const groupchatMarker = messageStanza && parseGroupchatMarkerStanza(messageStanza)
  const id = getStanzaId(archiveStanza) ?? nanoid()

  if (groupchatMarker && timestamp) {
    return {
      ...groupchatMarker,
      id,
      timestamp,
      paginationId: archiveStanza?.getAttr('id'),
    }
  }
}
